import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import { toast } from 'react-toastify';
import axios from 'axios';

const EditArea = ({ show, onClose,area,onUpdated }) => {
    // const option_branch = [
    //     { value: "0", label: "Madurai APF" },
    //     { value: "1", label: "Coimbatore" },
    //     { value: "2", label: "Trichy" },
    //     { value: "3", label: "Salem" },
    // ];
    // const [areaadd, setareaadd] = useState([{ id: Date.now() }]);
    const [areaadd, setareaadd] = useState([]);
    const [errors, setErrors] = useState({});
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        console.log(area);
    // console.log("Branch Data:", area?.branch_data); 
    // console.log("Branch Name:", area?.branch_data?.branch_name);
    if (area?.area && Array.isArray(area.area)) {
        setareaadd(
        area.area.map((a) => ({
            id: a.sno || Date.now(), 
            sno: a.sno,
            area_name: a.area_name || '',
            status: Number(a.status) || 0,
        }))
        );
        setErrors({});
    } else {
        
        setareaadd([{ id: Date.now(), area_name: '', status: 0 }]);
        setErrors({});
    }
    }, [area]);

    useEffect(() => {
        if (!show) {
          setareaadd([{ id: Date.now(), area_name: '' }]);
          setErrors({});
        }
      }, [show]);


    // const handleAddConfig = () => {
    //     setareaadd([...areaadd, { id: Date.now(), area_name: '' }]);
    // };

    const handleAddConfig = () => {
        setareaadd([...areaadd, { id: Date.now(), area_name: '', status: 0 }]);
        setErrors((prev) => ({ ...prev, [Date.now()]: '' }));
    };

    const handleDeleteArea = async (id, sno) => {
        try {
            if (sno) {
                // console.log(`Deleting area with sno: ${sno}`);
                await axios.delete(`${baseURL}/managearea/${sno}`);
            }

            setareaadd(prev => prev.filter(a => a.id !== id));
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[id];
                return newErrors;
            });
            onUpdated();
            // alert("Area deleted successfully.");
        } catch (error) {
            console.error("Failed to delete area:", error);
            // alert("Failed to delete area. Please try again.");
        }
    };


    // const handleChange = (id, value) => {
    //     setareaadd((prev) =>
    //     prev.map((a) => (a.id === id ? { ...a, area_name: value } : a))
    //     );
    // };

    const handleChange = (id, value) => {
        setareaadd((prev) =>
        prev.map((a) => (a.id === id ? { ...a, area_name: value } : a))
        );
        // Clear error for this field when user types
        setErrors((prev) => ({
        ...prev,
        [id]: value.trim() ? '' : prev[id],
        }));
    };

    const handleCancel = () => {
        setareaadd([{ id: Date.now(), area_name: '' }]); // Reset form fields to default
        setErrors({});
        onClose();  // Close the modal after resetting
    };

    const toggleStatus = async (id, sno, currentStatus) => {
    const newStatus = currentStatus === 0 ? 1 : 0;
    try {
        await axios.put(`${baseURL}/managearea/status/${sno}`, { status: newStatus });
        setareaadd(prev =>
        prev.map(a =>
            a.id === id ? { ...a, status: newStatus } : a
        )
        );
        onUpdated();
    } catch (error) {
        console.error("Failed to update status:", error);
        // alert("Failed to update status. Please try again.");
    }
    };

    const [selectedOption, setSelectedOption] = useState(null);
    const [isFocused] = useState(false);
    useEffect(() => {
        if (isFocused) {
            // console.log('The input is focused!');
        }
    }, [isFocused]);

    

    // const handleSubmit = async () => {
    //     // Validate all area_name fields
    //     const newErrors = {};
    //     let hasError = false;

    //     areaadd.forEach((a) => {
    //     if (!a.area_name.trim()) {
    //         newErrors[a.id] = 'This field is required';
    //         hasError = true;
    //     }
    //     });

    //     // 2. Duplicate name validation (case-insensitive)
    //     const nameMap = {};
    //         trimmedAreas.forEach((a) => {
    //             const nameKey = a.area_name.toLowerCase();

    //             if (nameMap[nameKey]) {
    //                 // Both current and first duplicate should show an error
    //                 newErrors[a.id] = 'Area name already exists';
    //                 newErrors[nameMap[nameKey]] = 'Area name already exists';
    //                 hasError = true;
    //             } else {
    //                 // Store the first occurrence
    //                 nameMap[nameKey] = a.id;
    //             }
    //     });

    //     setErrors(newErrors);

    //     if (hasError) {
    //     return; // Stop submission if there are validation errors
    //     }
    //     const trimmedAreas = areaadd.map((a) => ({
    //         ...a,
    //         area_name: a.area_name.trim(),
    //     })).filter((a) => a.area_name !== '');

    //     if (trimmedAreas.length === 0) {
    //         alert('Please enter at least one area name.');
    //         return;
    //     }

    //     const existingAreas = trimmedAreas.filter((a) => a.sno);      
    //     const newAreas = trimmedAreas.filter((a) => !a.sno);          

    //     try {
    //         // Update existing areas one by one
    //         await Promise.all(
    //             existingAreas.map((a) =>
    //                 axios.put(`${baseURL}/managearea/${a.sno}`, {
    //                     branch_name: area.branch_data.sno,
    //                     area_name: a.area_name,
    //                     status: a.status,
    //                 })
    //             )
    //         );

    //         // Create new areas
    //         await Promise.all(
    //             newAreas.map((a) =>
    //                 axios.post(`${baseURL}/managearea`, {
    //                     branch_name: area.branch_data.sno,
    //                     area_name: a.area_name,
    //                     status: a.status,
    //                 })
    //             )
    //         );

    //         // alert('Areas updated successfully!');
    //         onUpdated();
    //         onClose();
    //         // window.location.reload();
    //     } catch (error) {
    //         console.log('Update failed:', error);
    //         const errorMessage =
    //             error.response?.data?.message || 'Failed to update areas. Try again.';
    //         // alert(errorMessage);
    //     }
    // };

    const handleSubmit = async () => {
        const newErrors = {};
        let hasError = false;

        // Trimmed version first
        const trimmedAreas = areaadd.map((a) => ({
            ...a,
            area_name: a.area_name.trim(),
        })).filter((a) => a.area_name !== '');

        // 1. Required field validation
        areaadd.forEach((a) => {
            if (!a.area_name.trim()) {
                newErrors[a.id] = 'This field is required';
                hasError = true;
            }
        });

        // 2. Duplicate name validation (case-insensitive)
        const nameMap = {};
        trimmedAreas.forEach((a) => {
            const nameKey = a.area_name.toLowerCase();

            if (nameMap[nameKey]) {
                newErrors[a.id] = 'Area name already exists';
                newErrors[nameMap[nameKey]] = 'Area name already exists';
                hasError = true;
            } else {
                nameMap[nameKey] = a.id;
            }
        });

        setErrors(newErrors);

        if (hasError) return;

        if (trimmedAreas.length === 0) {
            alert('Please enter at least one area name.');
            return;
        }

        const existingAreas = trimmedAreas.filter((a) => a.sno);      
        const newAreas = trimmedAreas.filter((a) => !a.sno);          

        try {
            await Promise.all(
                existingAreas.map((a) =>
                    axios.put(`${baseURL}/managearea/${a.sno}`, {
                        branch_name: area.branch_data.sno,
                        area_name: a.area_name,
                        status: a.status,
                    })
                )
            );

            await Promise.all(
                newAreas.map((a) =>
                    axios.post(`${baseURL}/managearea`, {
                        branch_name: area.branch_data.sno,
                        area_name: a.area_name,
                        status: a.status,
                    })
                )
            );
            toast.success("Areas Updated successfully!");
            onUpdated();
            onClose();
        } catch (error) {
            console.log('Update failed:', error);
            const errorMessage =
                error.response?.data?.message || 'Failed to update areas. Try again.';
                toast.error("Failed to update areas. Please try again.");
        }
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Area</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="mb-2">
                            <label class="col-12 text-black fs-7">Branch</label>
                            <label class="col-12 text-red font-w500 fs-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{area?.branch_data?.branch_name || 'N/A'}</label>
                        </div>
                        <div className="col-lg-12 mb-3">
                            <div className='row'>
                                <div className='scroll-y mh-350px py-2'>
                                    <div className="col-lg-12 mb-3">
                                        <div className="mb-3">
                                            {areaadd.map(config => (
                                                <div key={config.id} data-repeater-item>
                                                    <div className="row">
                                                        <div className='col-lg-8 col-xs-8 mb-2'>
                                                            <label className="text-black font-w500 fs-7">Area <span className="required">*</span></label>
                                                            <input type="text" className={`form-control ${errors[config.id] ? 'is-invalid' : ''}`} placeholder="Enter Area" maxLength={100} value={config.area_name}
                                                            onChange={(e) => handleChange(config.id, e.target.value)} />
                                                            {errors[config.id] && (<div className="invalid-feedback">{errors[config.id]}</div>)}
                                                        </div>
                                                        <div className='col-lg-2 col-xs-2 mt-4  px-2 py-2'>
                                                            <div className="form-check form-switch d-flex align-items-center ">
                                                                <input className="form-check-input me-2" type="checkbox" role="switch" checked={config.status === 0} onChange={() => toggleStatus(config.id, config.sno, config.status)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 col-xs-2  mb-2 px-1 py-1">
                                                            {/* {areaadd.length > 1 && ( */}
                                                            <button
                                                                className="btn btn-danger mt-4 px-2 py-2"
                                                                onClick={() => handleDeleteArea (config.id, config.sno)}
                                                                data-bs-toggle="tooltip"
                                                                data-bs-placement="top"
                                                                title="Delete"
                                                            >
                                                                <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                            </button>
                                                            {/* )} */}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-1 mt-1">
                                    <button
                                        className="btn btn-sm btn-primary py-1 px-2"
                                        onClick={handleAddConfig}
                                    >
                                        <span><i className="fa-solid fa-plus fs-7"></i></span>
                                        <span className='ms-2 fs-8'>Add More</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <button type="reset" className="btn btn-sm btn-secondary" onClick={handleCancel}>Cancel</button>
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Area</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditArea;
